import Vue from 'vue'
import Vuex from 'vuex'
import fccapi from './fccapi.js'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    token: null,
    competitions: [],
    user: {},
    errorCode: null,
    loading: false,
    competitionId: null,
    serverUnavailable: false,
    roles: [],
    dark: false
  },
  mutations: {
    storeToken: function (state, token){
      state.token = token;
      state.competitionId = null;
    },
    setCompetitions: function (state, competitions){
      state.competitions = competitions;
      if(state.competitionId == null){
        state.competitionId = competitions[competitions.length - 1].id;
      }
    },
    selectCompetition: function (state, id) {
      state.competitionId = id;
    },
    setUser: function (state, user){
      state.user = user;
    },
    setRoles: function (state, roles){
      state.roles = roles;
    },
    setErrorCode: function (state, errorCode){
      state.errorCode = errorCode
    },
    setLoading: function (state, loading){
      state.loading = loading;
    },
    setServerUnavailable: function(state, unavailable){
      state.serverUnavailable = unavailable;
    },
    setDark: function(state, dark) {
      state.dark = dark;
    }
  },
  actions: {
    authRequest: (context, credentials) => {
      return new Promise((resolve, reject) => {
        fccapi.login(credentials).then((token) => {
          context.commit('storeToken', token);
          resolve();
        }).catch(() => {
          context.commit('storeToken', null);
          reject();
        });
      });
    },
    logout: (context) => {
      context.commit('storeToken', null);
      context.commit('setUser', null);
    },
    loadBaseData: ({commit, dispatch}) => {
      return new Promise((resolve, reject) => {
        dispatch('loadCompetitions').then(rr => {
          fccapi.get('user').then((r) => {
            commit('setUser', r.data);
            fccapi.get(`roles`).then(roles => {
                commit('setRoles', roles.data)
                resolve(r.data);
            })
          }).catch(e => {reject(e)});
        });
      });
    },
    loadCompetitions: (context) => {
      if(context.getters['isAuthenticated']){
        return new Promise((resolve, reject) => {
          fccapi.get('competitions').then((r)=>{
            context.commit('setCompetitions', r.data);
            resolve(r.data);
          });
        });
      }else{
        return new Promise((resolve, reject) => {
          fccapi.get('competitions/public').then((r)=>{
            context.commit('setCompetitions', r.data);
            resolve(r.data);
          });
        });
      }
    },
    selectCompetition: (context, id) => {
      context.commit('selectCompetition', id);
    },
    reportError: (context, code) => {
      context.commit('setErrorCode', code);
    },
    setLoading: (context, loading) => {
      context.commit('setLoading', loading);
    },
    setServerUnavailable: (context, unavailable) => {
      context.commit('setServerUnavailable', unavailable);
    },
    setDark: (context, dark) => {
      context.commit('setDark', dark);
    }
  },
  getters: {
    isAuthenticated: state => {
      return !!state.token;
    },
    competitions: state => state.competitions,
    token: state => state.token,
    username: state => state.user.userName,
    user: state => state.user,
    competitionId: state => state.competitionId,
    hasError: state => state.errorCode != null,
    errorCode: state => state.errorCode,
    loading: state => state.loading,
    competition: state => state.competitions.find(c => c.id == state.competitionId),
    isReferee: state => state.roles.filter(r => r.id === "competitionreferee-"+state.competitions.find(c => c.id == state.competitionId).id).length > 0,
    isAdministrator: state => state.token && JSON.parse(atob(state.token.split('.')[1])).roles == "Administrator",
    serverUnavailable: state => state.serverUnavailable,
    dark: state => state.dark
  }
})
